import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setAuthed } from '../redux/slice/login/loginSlice';
import { broadcastAuthLogout } from './useTabSync';

export const useAuth = (): any => {
  const loginData = useSelector((state: any) => state.login);
  const dispatch = useDispatch();
  useEffect(() => {
    const token = sessionStorage.getItem('access_token') || '';
    if (token) {
      dispatch(
        setAuthed({
          authed: true,
          token,
        })
      );
    }
  }, []);
  const login = (data: any): Promise<boolean> => {
    return new Promise(res => {
      dispatch(
        setAuthed({
          authed: true,
          token: data,
        })
      );
      res(true);
    });
  };
  const logout = (): Promise<boolean> => {
    broadcastAuthLogout();
    return new Promise(res => {
      dispatch(
        setAuthed({
          authed: false,
          token: null,
        })
      );
      sessionStorage.removeItem('access_token');
      Object.keys(sessionStorage)
        .filter(key => key.startsWith('alerts_seen_count_'))
        .forEach(key => sessionStorage.removeItem(key));
      res(true);
    });
  };
  return {
    authed: loginData.authed,
    value: loginData.value,
    login,
    logout,
  };
};
